import { questionnaireGql } from '../../../data/gql-gen/questionnaire'

export const UPDATE_SECTIONS_RANDOMISATION = questionnaireGql(/* GraphQL */ `
  mutation updateSectionsRandomisationV2(
    $input: UpdateSectionsRandomisationV2Input!
  ) {
    updateSectionsRandomisationV2(input: $input)
  }
`)
